// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"587":"c90f6f95","662":"6c05ade7","787":"128fc6e9","913":"102cd620","933":"cc6ce53f"}[chunkId] + ".chunk.js";
};